module.exports = __webpack_public_path__ + "img/143.c16e9569.jpg";